import { MicrosoftStoreAdsPageGA } from '../configs/tools/shared-library/product-feed';

export const microsoftStoreAds = {
  ...MicrosoftStoreAdsPageGA,
  name: _TL_('Microsoft Store Ads'),
  description: _TL_('Create and manage ads targeted towards customers browsing the Microsoft Store.'),
};
